var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilev2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#639dohtnea)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 6.5a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0z",
    stroke: "#808B9A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.018 4.978c0 .284-.09.51-.27.677a.939.939 0 0 1-.662.251c-.156 0-.31-.02-.462-.058a4.92 4.92 0 0 1-.393-.117 1.413 1.413 0 0 0-.228.234 9.29 9.29 0 0 0-.342.44c.116.498.21.853.282 1.063.072.209.14.422.204.637a.91.91 0 0 0 .244.402c.108.097.277.145.509.145.084 0 .19-.016.317-.049a2.56 2.56 0 0 0 .313-.098l-.108.442a5.964 5.964 0 0 1-.844.3c-.24.063-.455.093-.644.093-.138 0-.272-.013-.406-.039a1.078 1.078 0 0 1-.365-.142 1.105 1.105 0 0 1-.306-.267 1.431 1.431 0 0 1-.212-.45 3.824 3.824 0 0 1-.108-.41 6.789 6.789 0 0 0-.099-.406c-.094.14-.163.244-.205.313a14.6 14.6 0 0 1-.185.288c-.257.394-.48.675-.67.842a.987.987 0 0 1-.678.252.71.71 0 0 1-.508-.2.688.688 0 0 1-.21-.523c0-.29.09-.518.27-.687a.943.943 0 0 1 .664-.25c.156 0 .306.018.45.056.144.037.28.078.406.124.049-.04.125-.115.228-.23.103-.114.214-.255.335-.425a19.506 19.506 0 0 0-.266-.986l-.211-.66a.887.887 0 0 0-.255-.403c-.11-.096-.276-.143-.498-.143-.098 0-.207.017-.327.051-.121.035-.222.066-.303.095l.108-.441c.293-.132.57-.23.831-.296.263-.066.482-.098.657-.098.16 0 .297.012.41.034.114.023.235.071.36.146.118.072.22.162.306.271a1.3 1.3 0 0 1 .212.447c.04.13.077.266.11.405l.084.362.212-.323c.073-.11.136-.208.187-.293.252-.394.476-.676.675-.848a.998.998 0 0 1 .672-.256c.205 0 .376.067.513.202a.707.707 0 0 1 .206.526z",
    fill: "#808B9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "639dohtnea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilev2);
export default __webpack_public_path__ + "static/media/profilev2.d5bf2698a4013ebb4f9c20651257c937.svg";
export { ForwardRef as ReactComponent };